// Utility: debounce for click handlers
function debounceNew(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Wishlist manager class
class dTX_WhistList {
  constructor() {
    this.LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
    this.LOCAL_STORAGE_DELIMITER = ',';
  }

  getWishlist() {
    const wishlist = localStorage.getItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    return wishlist ? wishlist.split(this.LOCAL_STORAGE_DELIMITER) : [];
  }

  setWishlist(array) {
    if (array.length) {
      localStorage.setItem(this.LOCAL_STORAGE_WISHLIST_KEY, array.join(this.LOCAL_STORAGE_DELIMITER));
    } else {
      localStorage.removeItem(this.LOCAL_STORAGE_WISHLIST_KEY);
    }
    return array;
  }

  updateWishlist(handle) {
    const wishlist = this.getWishlist();
    const index = wishlist.indexOf(handle);
    if (index === -1) {
      wishlist.push(handle);
    } else {
      wishlist.splice(index, 1);
    }
    return this.setWishlist(wishlist);
  }

  removeWhishlist(handle) {
    return this.setWishlist(this.getWishlist().filter(h => h !== handle));
  }

  isAddedIntoList(handle) {
    return this.getWishlist().includes(handle);
  }

  async getProductResponse(url) {
    try {
      const response = await fetch(url);
      const product = await response.json();

      return {
        product_title: product.title,
        product_handle: product.handle,
        product_image: product.featured_image,
        money_price: Shopify.formatMoney(product.price, "{{amount}}"),
        product_url: `/products/${product.handle}`,
        variant_id: product.variants[0].id
      };
    } catch (error) {
      console.error('Error fetching product:', url, error);
      return null;
    }
  }

  async setupGrid() {
    const handles = this.getWishlist();
    const requests = handles.map(h => this.getProductResponse(`/products/${h}.js`));
    const results = await Promise.all(requests);
    return results.filter(r => r !== null);
  }

  getTotalCount() {
    return this.getWishlist().length;
  }
}

// Custom element for add/remove wishlist buttons
class dTXWhishList extends HTMLElement {
  constructor() {
    super();

    this.dTWhistList = new dTX_WhistList();
    this.addWishList = this.querySelector('.add-wishlist');

    if (this.addWishList && this.addWishList.hasAttribute("data-product_handle")) {
      this.productHandle = this.addWishList.getAttribute('data-product_handle');

      this.addWishList.addEventListener(
        'click',
        debounceNew(this.onSubmitHandler.bind(this), 500)
      );

      this.initLoad();
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();

    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
      window.location = "/pages/wishlist";
    } else {
      this.addWishList.classList.add("adding");
      this.dTWhistList.updateWishlist(this.productHandle);

      setTimeout(() => {
        this.updateCounter();
        this.addWishList.classList.remove("adding");
        this.addWishList.classList.add("added");
      }, 500);
    }
  }

  updateCounter() {
    const count = this.dTWhistList.getTotalCount();
    document.querySelectorAll(".dt-wishlist-cnt").forEach(el => {
      el.innerHTML = count;
      el.classList.toggle("hidden", count <= 0);
    });
  }

  initLoad() {
    if (this.dTWhistList.isAddedIntoList(this.productHandle)) {
      this.addWishList.classList.add("added");
    }
  }
}

customElements.define('dtx-wishlist', dTXWhishList);

// Vue mount block for rendering the wishlist grid
document.addEventListener('DOMContentLoaded', function () {
  console.log("✅ wish-list.js loaded. Initializing Vue...");

  new Vue({
    el: '#dT_WishListGrid',
    data: {
      wishList: [],
      isNoRecords: false
    },
    created() {
      const WL = new dTX_WhistList();
      WL.setupGrid().then(products => {
        console.log("✅ Vue is mounted. Products loaded:", products);
        this.wishList = products;
        this.isNoRecords = products.length === 0;
      });
    },
    methods: {
      remove(handle) {
        const WL = new dTX_WhistList();
        WL.removeWhishlist(handle);
        this.wishList = this.wishList.filter(item => item.product_handle !== handle);
        this.isNoRecords = this.wishList.length === 0;
      }
    }
  });
});


    